// W3C Drafts
require('./cssBlankPseudo')(document);
